import GroupLayout from "./GroupLayout";

const RyanLayout = () => (
  <GroupLayout
    brandName="VGOS"
    logoUrl="https://s3.ap-south-1.amazonaws.com/media.univariety.dev/images/Alumni+Logo.png"
    groupId="20000000015"
    headline="VIBGYOR Group of Schools"
  />
);

export default RyanLayout;
